var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageRecieved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 27.5L5.5 2.5 18.8 2.5 24.5 8.2 24.5 27.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M18.6,3L24,8.4V27H6V3H18.6 M19,2H5v26h20V8L19,2L19,2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5d4de",
    d: "M9 12H21V13H9zM9 15H19V16H9zM9 18H21V19H9zM9 21H19V22H9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 8.5L18.5 2.5 18.8 2.5 24.5 8.2 24.5 8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M19,3.4L23.6,8H19V3.4 M19,2h-1v7h7V8L19,2L19,2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6e3ed",
    d: "M24 15L24 27 10 27 10 28 25 28 25 15z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M12.5 17.5H29.5V29.5H12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M29,18v11H13V18H29 M30,17H12v13h18V17L30,17z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M12.3,20.2l7.5,4c0.8,0.4,1.7,0.4,2.4,0l7.5-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M21,25c-0.5,0-1-0.1-1.5-0.4l-7.5-4l0.5-0.9l7.5,4c0.6,0.3,1.3,0.3,2,0l7.5-4l0.5,0.9l-7.5,4 C22,24.9,21.5,25,21,25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRecieved);
export default __webpack_public_path__ + "static/media/message--recieved.b09e8ca91bcce0f0c15edaed7b3e5b79.svg";
export { ForwardRef as ReactComponent };